import {Store} from 'redux';
import {Preferences} from '@/app/interfaces/preferences';
import {ClockType, PressureUnit, SpeedUnit, TemperatureUnit} from '@/common/constants/units';
import {StoreState, StoreThunkDispatch} from '@/app/store';
import {updatePreferencesAction} from '@/app/store/config/actions';

const langValueMap: Record<string, string> = {
	ua: 'uk',
	ru: 'ru',
	en: 'en',
	de: 'de',
	pl: 'pl',
};

const temperatureValueMap: Record<string, TemperatureUnit> = {
	celsius: TemperatureUnit.celsius,
	fahrenheit: TemperatureUnit.fahrenheit,
};

const speedValueMap: Record<string, SpeedUnit> = {
	ms: SpeedUnit.ms,
	kmh: SpeedUnit.kph,
	mph: SpeedUnit.mph,
};

const pressureMap: Record<string, PressureUnit> = {
	mm: PressureUnit.mmHg,
	mb: PressureUnit.dmHg,
	hpa: PressureUnit.hPa,
};
const clockTypeMap: Record<string, ClockType> = {
	'12': ClockType['12h'],
	'24': ClockType['24h'],
};

export async function migrateLegacyConfig(store: Store<StoreState>) {
	const lang = localStorage.getItem('current_lang');
	const temperatureUnit = localStorage.getItem('temperature_type');
	const speedUnit = localStorage.getItem('speed_type');
	const pressureUnit = localStorage.getItem('pressure_type');
	const clockType = localStorage.getItem('time_type');

	const newConfigPatch: Partial<
		Pick<Preferences, 'lang' | 'temperatureUnit' | 'pressureUnit' | 'speedUnit' | 'clockType'>
	> = {};

	if (lang && Object.keys(langValueMap).includes(lang)) {
		newConfigPatch.lang = langValueMap[lang];
	}

	if (temperatureUnit && Object.keys(temperatureValueMap).includes(temperatureUnit)) {
		newConfigPatch.temperatureUnit = temperatureValueMap[temperatureUnit];
	}

	if (speedUnit && Object.keys(speedValueMap).includes(speedUnit)) {
		newConfigPatch.speedUnit = speedValueMap[speedUnit];
	}

	if (pressureUnit && Object.keys(pressureMap).includes(pressureUnit)) {
		newConfigPatch.pressureUnit = pressureMap[pressureUnit];
	}

	if (clockType && Object.keys(clockTypeMap).includes(clockType)) {
		newConfigPatch.clockType = clockTypeMap[clockType];
	}

	if (Object.keys(newConfigPatch).length === 0) {
		return;
	}

	try {
		console.log('Migrate legacy config', newConfigPatch);
		await (store.dispatch as StoreThunkDispatch)(updatePreferencesAction(newConfigPatch));
	} catch (error) {
		console.error(error);
		return;
	}

	localStorage.removeItem('current_lang');
	localStorage.removeItem('temperature_type');
	localStorage.removeItem('speed_type');
	localStorage.removeItem('pressure_type');
	localStorage.removeItem('time_type');
}
